import { render, staticRenderFns } from "./MyprofileBest3Card.vue?vue&type=template&id=d07617a0&scoped=true"
import script from "./MyprofileBest3Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyprofileBest3Card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyprofileBest3Card.vue?vue&type=style&index=0&id=d07617a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07617a0",
  null
  
)

export default component.exports